import "./Header.css";

export default function Header(){
    return (
        <header>
            <h1>Quiz App</h1>
        </header>
    )
}
